module.exports = __webpack_public_path__ + "static/media/12.6172d900.png";